module.exports = __webpack_public_path__ + "/static/ecsenz_logoWhite.svg";